import React from 'react';
import { Inbox } from 'lucide-react';

const AdminTicketsTab = ({ 
  tickets, 
  formatDate,
  getPriorityColor
}) => {
  return (
    <div className="admin-card full-width" data-testid="tickets-tab">
      <h2><Inbox className="h-5 w-5" /> Support Ticket History</h2>
      {tickets.length > 0 ? (
        <div className="tickets-list">
          {tickets.map((ticket) => (
            <div key={`ticket-${ticket._id || ticket.customer_email}-${ticket.created_at}`} className="ticket-item" data-testid={`ticket-item-${ticket._id || ticket.customer_email}`}>
              <div className="ticket-header">
                <span className="ticket-email">{ticket.customer_email}</span>
                <div className="ticket-badges">
                  <span 
                    className="admin-badge small"
                    style={{ background: getPriorityColor(ticket.priority) }}
                  >
                    {ticket.priority}
                  </span>
                  <span className="admin-badge category small">
                    {ticket.category?.replace('_', ' ')}
                  </span>
                </div>
              </div>
              <div className="ticket-subject">{ticket.subject}</div>
              <div className="ticket-preview">{ticket.customer_message?.substring(0, 150)}...</div>
              <div className="ticket-footer">
                <span className="ticket-date">{formatDate(ticket.created_at)}</span>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="admin-empty">
          <Inbox className="h-12 w-12" />
          <p>No support tickets yet. Process some emails to see them here!</p>
        </div>
      )}
    </div>
  );
};

export default AdminTicketsTab;
